import React, { useState, useEffect } from 'react';
//import { Container, Row, Col, Card, Button, Modal,Table , Badge} from "react-bootstrap";
import { Container, Row, Col, Card, Button, Modal, Table, Badge, Collapse } from "react-bootstrap";

import Papa from 'papaparse';
import SmallProjectCard from './SmallProjectCard';

function ProjectTable({ children,project }) {
  const [rotateX, setRotateX] = useState(0);
  const [rotateY, setRotateY] = useState(0);
  const [tableData, setTableData] = useState([]);
  const [expanded, setExpanded] = useState({});
  const toggle = (name) => setExpanded(prev => ({ ...prev, [name]: !prev[name] }));

  const convertCSVToJson = (csvText) => {
    return new Promise((resolve, reject) => {
      Papa.parse(csvText, {
        header: true, // Use the first row as headers
        skipEmptyLines: true, // Skip empty lines in the CSV file
        complete: function(results) {
          resolve(results.data); // Resolve with the parsed data
        },
        error: function(error) {
          reject(error); // Reject the promise on error
        }
      });
    });
  };
  
  
  useEffect(() => {
    const handleMouseMove = (event) => {
      const x = event.clientX - window.innerWidth / 2;
      const y = event.clientY - window.innerHeight / 2;
      setRotateX(-y / 2000);
      setRotateY(x / 1000);
    };
    window.addEventListener('mousemove', handleMouseMove);

  function preprocessData(data) {
    const processedData = data.map(item => ({
      ...item,
      start: formatDate(item.start),
      end: formatDate(item.end)
    })).sort((a, b) => new Date(b.end) - new Date(a.end)); // Sort descending by start date
    data.map(item => {

    //console.log("LOADED DATA");
    //console.log({item});

    });

    return processedData;
  }
  // src/utils/colorMap.js
   const COLOR_MAP = {
    ai: '#9B51E0',
    back_end: '#2ECC71',
    front_end: '#F5A623',
    art: '#e9683d',
    web_3: '#33c9ff',
  }
   const DEFAULT_COLOR = '#000000'

   function getColor(type) {
    return COLOR_MAP[type] || DEFAULT_COLOR
  }
    
  function combineData(data) {
    console.log("REDING TAGS------")
    return data.reduce((acc, item) => {
      const formattedItem = item;
      //console.log("raw item ");
      //console.log({item});

      if (formattedItem.show != 1)
        return acc;
      // Check if the company already exists in the accumulator
        if (!acc[formattedItem.name]) {
          // If not, initialize it
          acc[formattedItem.name] = {
            name:formattedItem.name,
            description: "None",
            roles: []
        };
        
        if (formattedItem.type) 
        {
          acc[formattedItem.name].type = formattedItem.type;
        }
        else
        {
          acc[formattedItem.name].type = "ai";
        }

        if (formattedItem.tags) {

          const rawTags = Array.isArray(formattedItem.tags)
              ? formattedItem.tags
              : formattedItem.tags.split(',');
          
          acc[formattedItem.name].tags = rawTags;
          console.log(acc[formattedItem.name].tags);
        }

      }
      if (formattedItem.project_name.length == 0)
      {
        acc[formattedItem.name].description = formattedItem.project_description;
      }
      else
      {

        if (!formattedItem.type)
        {
          formattedItem.type = 'back_end';

        }
        formattedItem.border_color = getColor(formattedItem.type);

        if (!formattedItem.img)
        {
          formattedItem.img =  formattedItem.type+".png";

        }
        acc[formattedItem.name].roles.push(formattedItem);

      }
      return acc;
    }, {});
  }

    // Fetch the CSV file from the public directory
    fetch('projects.csv')
    .then(response => response.text())  // Directly read the response as text
    .then(csvText => {
      console.log(csvText);
      convertCSVToJson(csvText).then(data => {  // Assuming convertCSVToJson accepts a CSV string
        //console.log(data);
        /// &#172; How do I replace / render any special entities in the code?
        data = preprocessData(data);

        var final_data = combineData(data);
        
        const arr = Object.values(final_data)

        // 2) mutate each item
        arr.forEach(item => {
              console.log({item});

              if( item.roles)
              {
                item.roles.forEach(project  => 
                {
                    //console.log("project.type");
                    //console.log(project.type);
                    //console.log({project});
                      //project.tags = ['z','b','z']
                    
                    
                    if (project.tags == null) {
                      // 1) if null or undefined
                      project.tags = [];
                    } else if (typeof project.tags === 'string') {
                      // 2) if a comma-separated string
                      project.tags = project.tags
                        .split(',')
                        .map(tag => tag.trim())
                        .filter(tag => tag);
                    }                      
                })

              }
        })   
         
        setTableData(Object.values(arr));  // Update state with parsed data
      });
    })
    .catch(error => {
      console.error('Error fetching CSV file:', error);
    });  

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);
  
  function formatDate(dateString) {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    const lowerCasedDate = dateString.toLowerCase(); // Convert to lower case to handle case insensitivity
  
    if (lowerCasedDate.includes("present")) {
      return new Date().toLocaleDateString('en-US', options);
    } else {
      return new Date(dateString).toLocaleDateString('en-US', options);
    }
  }
  
  const transform = {
    transform: `perspective(600px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`,
    transition: 'transform 0.1s'
  };
  // company	start	end	name	project_name	project_link	project_description	tags
 // Company section
 // Project card

 /**                  <Col xs={12} md={4} key={index} className="mb-4"> 
                    <Card.Text>TXT
                      {project.project_link ? (
                        <b><a href={project.project_link}>{project.project_name}:</a> </b>
                      ) : (
                        <b>{project.project_name}: </b>
                      )}
                      {project.project_description}
                    </Card.Text>
                    
                    */
 // Sub project list
    return (
      <Container>
        <Row className=" mb-4">
          <Col md={12}>
            <h1 className="display-5 mb-3">
             Major Projects
            </h1>
              <p className="lead">
                I have completed three major bodies of work; Decelium, a collection of self-hosting services; ¬misanthropy, a science fiction collection; and my publications, research on on robust Multi-Agent Reinforcement Learning techniques.
              </p>
              <Button
                as="a"
                href="https://calendly.com/justingirard/ai-art-chat"
                target="_blank"
                rel="noopener noreferrer"
                variant="primary"
                className="mt-3"
              >
               Book a conversation
              </Button>
          </Col>
        </Row>        
      <Row ></Row>        
      <Row>
        {tableData.map((item, index) => (
          <Col xs={12} md={12} key={index} className="mb-4"> 
            <Card style={transform}>
              <Card.Body>
                <Row>
                  <Col xs={12} md={8} key={index} className="mb-4"> 
                    <Card.Title  className="fs-3 " >{item.name}</Card.Title>
                    <Card.Text className="fs-4 " >{item.description}</Card.Text>
                    <Button
                      variant="link"
                      className="px-0"
                      onClick={() => toggle(item.name)}
                    >
                      {expanded[item.name] ? "Hide projects" : "Show projects"}
                    </Button>

                  </Col>
                  <Col xs={0} md={4}  className="mb-4">   
                  
                  </Col>
                <Collapse in={!!expanded[item.name]}>   
                 <Row>
                  {item.roles.map((project, index2) => (
                    <SmallProjectCard img={project.img} 
                                      title={project.project_name} 
                                      description={project.project_description} 
                                      tags = {project.tags}
                                      link={project.project_link}
                                      borderColor = {project.border_color}
                                      index= {index} ></SmallProjectCard>

                  ))}
                   </Row>
                  </Collapse>         
                </Row>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
      {children}
    </Container>
  );
}

export default ProjectTable;
